const permissionsFor = (user = {}) => Array.isArray(user.access) ? user.access : [];

export const hasCrmAccess = (user = {}) =>
  ['manager', 'admin', 'superAdmin'].includes(user.role) ||
  permissionsFor(user).some((permission) => ['crm', 'crmAdmin'].includes(permission));

export const hasCrmAdminAccess = (user = {}) =>
  ['manager', 'admin', 'superAdmin'].includes(user.role) ||
  permissionsFor(user).includes('crmAdmin');

export const hasCrmManagerAccess = (user = {}) =>
  ['manager', 'superAdmin'].includes(user.role) ||
  permissionsFor(user).includes('crmAdmin');

export const canUseCrmContacting = (user = {}) =>
  hasCrmManagerAccess(user) || permissionsFor(user).includes('crm');
